import Common from "../../../Common";

export interface PbxDestinationBrowse {
	id: id
	name: string
	destination: string
	description: string
}

export type PbxDestination = PbxDestinationBody & {
	src_pbx_destination_id?: id
}

export interface PbxDestinationBody {
	id: id
	name: string
	destination: string
	description: string
}

const body: PbxDestinationBody = {
	id: 0,
	name: '',
	destination: '',
	description: '',
}

export const getPbxDestinationBody = (replace: Partial<typeof body> = {}) => Object.assign(JSON.parse(JSON.stringify(body)), replace)

const Destination = class extends Common {
	browse = (companyId: id): CustomResponse<PbxDestinationBrowse[]> =>
		this.get(`/company/${companyId}/pbx/destination`);

	read = (companyId: id, id: id): CustomResponse<PbxDestination> =>
		this.get(`/company/${companyId}/pbx/destination/${id}`);

	create = (companyId: id, data: PbxDestinationBody, options?: DadExtraOptions) =>
		this.post(`/company/${companyId}/pbx/destination${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data);

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbx/destination/${id}`);
}

export default Destination
